import dispatcher from './dispatcher';
import { EXPORT_DB, DISMISS } from './Actions';
import { BASE_URL } from './AppConst';
import axios from 'axios';

export function ExportQuestions(postData) {
  dispatcher.dispatch({
    type: EXPORT_DB,
  });
}

export function Dismiss() {
  dispatcher.dispatch({
    type: DISMISS,
  });
}
